<template>
	<div class="wk-container">
		<NotificationItem />
		<div class="wk-column-menu" :class="{ 'menu-small': smallMenu }">
			<MainMenu />
		</div>

		<div class="wk-column">
			<div class="background-app" :class="{ 'margin-free-trials': isFreeTrials }">
				<div class="app">
					<slot />
				</div>
			</div>
			<FreeTrials />
			<ShopifyUpdateModal />
		</div>
	</div>
</template>

<script>
import MainMenu from '@/components/nav-bar/MainMenu.vue'
import NotificationItem from '@/components/notifications/notification'
import FreeTrials from '@/components/free-trials/free-trials.vue'
import ShopifyUpdateModal from '@/components/integrations/ShopifyUpdateModal'

export default {
	components: {
		MainMenu,
		NotificationItem,
		FreeTrials,
		ShopifyUpdateModal,
	},

	computed: {
		company() {
			return this.$store.state.company.company
		},

		smallMenu() {
			return this.$store.state.smallMenu
		},

		isFreeTrials() {
			return this.company?.plan_id === 2
		},
	},
}
</script>

<style>
.main-container {
	height: 100%;
}

.wk-container {
	display: flex;
	width: 100%;
}

.wk-column {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.wk-column-menu {
	display: flex;
	flex-direction: column;
	min-width: 220px;
}

.menu-small {
	min-width: 64px;
}

.background-app {
	height: 100%;
	width: 100%;
}

.v-popper--theme-tooltip .v-popper__inner {
	background: #130e4b;
	border-radius: 5px;
	color: white;
	padding: 7px;
	gap: 10px;
	font-weight: 400;
	font-size: 11px;
	line-height: 13px;
	display: flex;
	align-items: center;
	max-width: 250px;
}

.v-popper--theme-tooltip .v-popper__arrow-outer {
	border-color: #130e4b;
}

.margin-free-trials {
	margin-bottom: 60px;
}
.gta > iframe {
	display: none;
	visibility: hidden;
	height: 0px;
	width: 0px;
}
</style>
<style scoped>
.app {
	padding: 20px 0;
	max-width: 1140px;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
	height: 100dvh;
	display: flex;
	flex-direction: column;

	& > * {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
}
</style>
